import { IUser } from "@/features/admins/types";
import MyAxios from "@/utilize/MyAxios";
import { useMutation } from "@tanstack/react-query";

const useUpdateUser = () => {
  return useMutation({
    mutationFn: (payload: Partial<IUser>) => {
      const { id, ...rest } = payload;
      return MyAxios.patch(`/users/${id}`, rest);
    },
  });
};
export default useUpdateUser;
